// FETCH ALL PROCESS
export const FETCH_PROCESS_REQUEST = 'FETCH_PROCESS_REQUEST';
export const FETCH_PROCESS_SUCCESS = 'FETCH_PROCESS_SUCCESS';
export const FETCH_PROCESS_FAILURE = 'FETCH_PROCESS_FAILURE';

// CREATE PROCESS
export const CREATE_PROCESS_REQUEST = 'CREATE_PROCESS_REQUEST';
export const CREATE_PROCESS_SUCCESS = 'CREATE_PROCESS_SUCCESS';
export const CREATE_PROCESS_FAILURE = 'CREATE_PROCESS_FAILURE';

export const CREATE_COPY_PROCESS_REQUEST = 'CREATE_COPY_PROCESS_REQUEST';
export const CREATE_COPY_PROCESS_SUCCESS = 'CREATE_COPY_PROCESS_SUCCESS';
export const CREATE_COPY_PROCESS_FAILURE = 'CREATE_COPY_PROCESS_FAILURE';

// UPDATE PROCESS
export const UPDATE_PROCESS_REQUEST = 'UPDATE_PROCESS_REQUEST';
export const UPDATE_PROCESS_SUCCESS = 'UPDATE_PROCESS_SUCCESS';
export const UPDATE_PROCESS_FAILURE = 'UPDATE_PROCESS_FAILURE';

// FETCH SINGLE STATE OF PROCESS
export const FETCH_SINGLE_PROCESS_REQUEST = 'FETCH_SINGLE_PROCESS_REQUEST';
export const FETCH_SINGLE_PROCESS_SUCCESS = 'FETCH_SINGLE_PROCESS_SUCCESS';
export const FETCH_SINGLE_PROCESS_FAILURE = 'FETCH_SINGLE_PROCESS_FAILURE';

export const FETCH_PROGRAM_MAPPING_REQUEST = 'FETCH_PROGRAM_MAPPING_REQUEST';
export const FETCH_PROGRAM_MAPPING_SUCCESS = 'FETCH_PROGRAM_MAPPING_SUCCESS';
export const FETCH_PROGRAM_MAPPING_FAILURE = 'FETCH_PROGRAM_MAPPING_FAILURE';

// DELETE PROCESS
export const DELETE_PROCESS_REQUEST = 'DELETE_PROCESS_REQUEST';
export const DELETE_PROCESS_SUCCESS = 'DELETE_PROCESS_SUCCESS';
export const DELETE_PROCESS_FAILURE = 'DELETE_PROCESS_FAILURE';

// CREATE_ASSIGN PROCESS
export const CREATE_ASSIGN_PROCESS_REQUEST = 'CREATE_ASSIGN_PROCESS_REQUEST';
export const CREATE_ASSIGN_PROCESS_SUCCESS = 'CREATE_ASSIGN_PROCESS_SUCCESS';
export const CREATE_ASSIGN_PROCESS_FAILURE = 'CREATE_ASSIGN_PROCESS_FAILURE';

// FETCH ALL ASSIGN PROCESS
export const FETCH_ASSIGN_PROCESS_REQUEST = 'FETCH_ASSIGN_PROCESS_REQUEST';
export const FETCH_ASSIGN_PROCESS_SUCCESS = 'FETCH_ASSIGN_PROCESS_SUCCESS';
export const FETCH_ASSIGN_PROCESS_FAILURE = 'FETCH_ASSIGN_PROCESS_FAILURE';

// DELETE PROCESS
export const DELETE_ASSIGN_PROCESS_REQUEST = 'DELETE_ASSIGN_PROCESS_REQUEST';
export const DELETE_ASSIGN_PROCESS_SUCCESS = 'DELETE_ASSIGN_PROCESS_SUCCESS';
export const DELETE_ASSIGN_PROCESS_FAILURE = 'DELETE_ASSIGN_PROCESS_FAILURE';

// UPDATE ASSIGN_PROCESS
export const UPDATE_ASSIGN_PROCESS_REQUEST = 'UPDATE_ASSIGN_PROCESS_REQUEST';
export const UPDATE_ASSIGN_PROCESS_SUCCESS = 'UPDATE_ASSIGN_PROCESS_SUCCESS';
export const UPDATE_ASSIGN_PROCESS_FAILURE = 'UPDATE_ASSIGN_PROCESS_FAILURE';

// FETCH SINGLE STATE OF ASSIGN_PROCESS
export const FETCH_SINGLE_ASSIGN_PROCESS_REQUEST = 'FETCH_SINGLE_ASSIGN_PROCESS_REQUEST';
export const FETCH_SINGLE_ASSIGN_PROCESS_SUCCESS = 'FETCH_SINGLE_ASSIGN_PROCESS_SUCCESS';
export const FETCH_SINGLE_ASSIGN_PROCESS_FAILURE = 'FETCH_SINGLE_ASSIGN_PROCESS_FAILURE';

// FETCH ALL ASSIGN PROCESS BY STYLE ID
export const FETCH_ASSIGN_PROCESS_STYLE_BY_ID_REQUEST = 'FETCH_ASSIGN_PROCESS_STYLE_BY_ID_REQUEST';
export const FETCH_ASSIGN_PROCESS_STYLE_BY_ID_SUCCESS = 'FETCH_ASSIGN_PROCESS_STYLE_BY_ID_SUCCESS';
export const FETCH_ASSIGN_PROCESS_STYLE_BY_ID_FAILURE = 'FETCH_ASSIGN_PROCESS_STYLE_BY_ID_FAILURE';

// FETCH ALL ASSIGN PROCESS BY STYLE ID
export const FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_REQUEST = 'FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_REQUEST';
export const FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_SUCCESS = 'FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_SUCCESS';
export const FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_FAILURE = 'FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_FAILURE';

export const RESET_PROCESS_INFO = 'RESET_PROCESS_INFO';

export const RESET_ASSIGN_PROCESS_INFO = 'RESET_ASSIGN_PROCESS_INFO';

export const CREATE_PROCESS_FORM = 'CREATE_PROCESS_FORM';
export const CREATE_ASSIGN_PROCESS_FORM = 'CREATE_ASSIGN_PROCESS_FORM';

export const UPDATE_PROCESS_FORM = 'UPDATE_PROCESS_FORM';
export const UPDATE_ASSIGN_PROCESS_FORM = 'UPDATE_ASSIGN_PROCESS_FORM';

// NAVIGATE TO PROCESS DETAILS COMPONENT
export const NAVIGATE_PROCESS_DETAILS = 'NAVIGATE_PROCESS_DETAILS';

// NAVIGATE TO PROCESS COMPONENT
export const NAVIGATE_PROCESS = 'NAVIGATE_PROCESS';
